import script from "./Sprachtechnik-Ext-Course-Maker.vue?vue&type=script&setup=true&lang=js"
export * from "./Sprachtechnik-Ext-Course-Maker.vue?vue&type=script&setup=true&lang=js"

import "./Sprachtechnik-Ext-Course-Maker.vue?vue&type=style&index=0&id=6050542f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6050542f"]])

export default __exports__